module.exports = __webpack_public_path__ + "img/Enmascarar grupo 25@2x.734937e1.png";